import { PayloadAction } from '@reduxjs/toolkit';
import { trackException } from 'app-insights/appInsightsTracking';
import { CasesService } from 'app/services/CandidateServices/cases-service';
import { httpSuccess } from 'app/services/serviceHelpers';
import { call, getContext, put } from 'redux-saga/effects';
import { casesActions } from './slice';

export function* getCasesWorker(
  action: PayloadAction<{ travelerId: number; placementId?: string; status?: string }>,
) {
  yield put(casesActions.setLoading(true));
  yield put(casesActions.setServiceFailure(false));
  try {
    const casesService: CasesService = yield getContext('casesService');
    const { travelerId, placementId, status } = action.payload;
    const response = yield call([casesService, casesService.getCases], travelerId, placementId, status);
    if (httpSuccess(response?.status)) {
      yield put(casesActions.setCases(response.data));
    } else {
      yield put(casesActions.setServiceFailure(true));
    }
  } catch (error) {
    yield put(casesActions.setServiceFailure(true));
    trackException({
      exception: error,
      properties: { functionName: 'getCasesWorker', area: 'cases/business.saga.ts' },
    });
  } finally {
    yield put(casesActions.setLoading(false));
  }
}

export function* getCaseDetailWorker(action: PayloadAction<{ sfCaseId: string }>) {
  yield put(casesActions.setDetailLoading(true));
  yield put(casesActions.setServiceFailure(false));
  yield put(casesActions.clearSelectedCase());
  try {
    const casesService: CasesService = yield getContext('casesService');
    const response = yield call([casesService, casesService.getCaseDetail], action.payload.sfCaseId);
    if (httpSuccess(response?.status)) {
      yield put(casesActions.setSelectedCase(response.data));
    } else {
      yield put(casesActions.setServiceFailure(true));
    }
  } catch (error) {
    yield put(casesActions.setServiceFailure(true));
    trackException({
      exception: error,
      properties: { functionName: 'getCaseDetailWorker', area: 'cases/business.saga.ts' },
    });
  } finally {
    yield put(casesActions.setDetailLoading(false));
  }
}
